///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/client-type.collection.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ClientTypesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected clientTypes: ClientTypeCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.clientTypes;
        }

        get totalSelectedCount(): number {
            return this.clientTypes.value.length;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.clientTypes = new ClientTypeCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                smartMoverHidden: () => this.smartMoverHidden,
            });

            this.filters = [
                new ActiveInactiveFilter({hideInactiveLabel: 'LABEL_HIDE_INACTIVE_CLIENT_TYPES'}, this)
            ];
            this.clientTypes.addFilters(...this.filters as IInteractiveFilter[]);

            this.title = 'LABEL_CLIENTTYPES';
            this.allSelectedLabel = 'LABEL_ALL_CLIENT_TYPES';
            this.totalSelectedMessage = 'LABEL_TOTAL_CLIENT_TYPES_SELECTED';

            if (options.required) {
                this.validation.push(new RequiredValidation(this.collection, 'LABEL_CLIENT_TYPE_REQUIRED'));
            }
        }

        setWatchers(scope: angular.IScope) {
            this.clientTypes.setWatchers(scope);

            super.setWatchers(scope);
        }
    }
}
